import { useAuthenticator } from '@aws-amplify/ui-react';
import { IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import sentinelImg from '../../assets/images/SentinelLogo.png';
import { DqText } from '../../components/dq-text';
import { HomeMessages } from '../../intl/HomeMessages';
import { selectAuthUserInfo } from '../../redux/auth/selectors';
import { useLogOut } from '../../utils/auth/useLogOut';
import { selectBleConnectedDevice } from 'src/redux/ble/selectors';
import { BleService } from 'src/ble/BleService';
import { useGA4 } from '../../utils/ga4';

export const LogoutPage: React.FC = () => {
  document.title = 'Logout Page'; // Purposely English only for Google Analytics
  useGA4();

  const { formatMessage } = useIntl();
  const history = useHistory();
  const logOut = useLogOut();
  const userInfo = useSelector(selectAuthUserInfo);
  const connectedDevice = useSelector(selectBleConnectedDevice);
  const { authStatus } = useAuthenticator(s => [s.authStatus]);

  React.useEffect(() => {
    const exec = async () => {
      try {
        if (connectedDevice?.deviceId) {
          await BleService.disconnect(connectedDevice.deviceId);
        }
        await logOut();
        history.push('/landing');
      } catch (err) {
        console.error('Error logging out:', err);
        window.location.reload();
      }
    };

    // We only want to run logout if the user arrived at the logout page with a user context.
    if (userInfo) exec();
  }, [connectedDevice?.deviceId, history, logOut, userInfo]);

  React.useEffect(() => {
    if (authStatus !== 'authenticated') history.push('/');
  }, [authStatus, history]);

  return (
    <IonPage>
      <IonContent>
        <IonGrid className="ion-margin-top">
          <IonRow>
            <IonCol sizeSm="12" sizeMd="6" sizeLg="4" offsetSm="0" offsetMd="3" offsetLg="4">
              <IonCard class="sign-in-card">
                <IonCardContent>
                  <IonGrid>
                    <IonRow>
                      <IonCol class="ion-text-center">
                        <div>
                          <IonImg className="welcome-img" src={sentinelImg} />
                        </div>
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol class="ion-text-center">
                        <div>
                          <DqText variant="h2">{formatMessage(HomeMessages.loggedOutTitle)}</DqText>
                        </div>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
